import React from 'react';
import {ChakraProvider, extendTheme} from '@chakra-ui/react';
import {Page} from './stories/Page';

function App() {
    const customTheme = extendTheme({
        config: {
            initialColorMode: 'dark',
            useSystemColorMode: false,
        },
    });
    return (
        <ChakraProvider theme={customTheme}>
            <Page/>
        </ChakraProvider>
    );
}

export default App;
